import config from '@/config.js';
//import Vue from 'vue'
import socketio from 'socket.io-client';
//import VueSocketIO from 'vue-socket.io';

let SocketInstance = null;
let token = window.localStorage.getItem('__ksrms-token');

if (config.socketServerUrl && token) {
  SocketInstance = socketio(config.socketServerUrl, { transports: ['websocket'], auth: { token: token } });
  //Vue.use(new VueSocketIO({debug:false, connection: SocketInstance}));
}

export default SocketInstance;
